import React, { useState } from "react";
import { motion } from "framer-motion";
import { Check, ArrowUpRight, Star } from "lucide-react";
import { SERVICES } from "../mock";
import BookingDialog from "./BookingDialog";

const cardVariants = {
  hidden: { opacity: 0, y: 60 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.12, duration: 0.7, ease: [0.16, 1, 0.3, 1] },
  }),
};

const Services = () => {
  const [selected, setSelected] = useState(null);
  const [open, setOpen] = useState(false);

  const handleReserve = (service) => {
    setSelected({
      kind: "service",
      itemId: service.id,
      itemName: service.title,
      price: service.price,
    });
    setOpen(true);
  };

  return (
    <section id="services" className="section-pad relative bg-[#08080a]">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl mb-16"
        >
          <span className="eyebrow">Mes services</span>
          <h2 className="section-title text-4xl md:text-6xl text-white mt-5">
            Un accompagnement <span className="racing-text">sur-mesure</span>
          </h2>
          <p className="mt-5 text-white/60 text-lg leading-relaxed">
            Que vous vouliez tout déléguer ou juste un coup de pouce, choisissez
            la formule adaptée à votre projet automobile.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {SERVICES.map((service, i) => (
            <motion.div
              key={service.id}
              custom={i}
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              className={`card-lift relative rounded-2xl overflow-hidden border ${
                service.highlight
                  ? "border-[#ff6a00]/40 bg-gradient-to-br from-[#16100e] to-[#0e0e11]"
                  : "border-white/8 bg-[#0e0e11]"
              }`}
            >
              {service.highlight && (
                <div className="absolute top-5 right-5 z-20 flex items-center gap-1.5 bg-gradient-to-r from-[#e11d2a] to-[#ff6a00] text-white text-xs font-display font-semibold px-3 py-1.5 rounded-full">
                  <Star size={12} fill="white" /> Populaire
                </div>
              )}
              <div className="relative h-52 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-700 hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0e0e11] via-transparent to-transparent" />
                <span className="absolute bottom-4 left-5 text-[11px] font-display tracking-[0.2em] uppercase text-[#ff8a4c]">
                  {service.tagline}
                </span>
              </div>

              <div className="p-7">
                <div className="flex items-start justify-between gap-4">
                  <h3 className="font-display font-bold text-2xl text-white">
                    {service.title}
                  </h3>
                  <span className="font-display font-extrabold text-2xl racing-text whitespace-nowrap">
                    {service.price}
                  </span>
                </div>
                <p className="mt-3 text-white/55 leading-relaxed text-[15px]">
                  {service.description}
                </p>
                <ul className="mt-6 space-y-3">
                  {service.features.map((f, idx) => (
                    <li key={idx} className="flex items-center gap-3 text-white/75 text-sm">
                      <span className="flex-shrink-0 w-5 h-5 rounded-full bg-[#e11d2a]/15 flex items-center justify-center">
                        <Check size={13} className="text-[#ff5a1f]" />
                      </span>
                      {f}
                    </li>
                  ))}
                </ul>
                <button
                  onClick={() => handleReserve(service)}
                  className={service.highlight ? "btn-racing mt-7 w-full justify-center" : "btn-ghost mt-7 w-full justify-center"}
                >
                  Réserver <ArrowUpRight size={18} />
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <BookingDialog open={open} onOpenChange={setOpen} item={selected} />
    </section>
  );
};

export default Services;
